import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const TableWrapper = styled.div`
	width: 100%;
	height: 100%;
	overflow-y: auto;

	.ag-theme-balham {
		width: 100%;
		height: 100%;
		font-family: 'Roboto';

		.ag-root,
		.ag-side-bar,
		.ag-root-wrapper,
		.ag-status-bar {
		}

		.ag-header-row {
			border-bottom: 0px;
		}

		.ag-header {
			padding: 0px;
			background-color: #5cb335;
			color: white;
			.ag-header-cell-resize {
				display: none;
			}
			.ag-icon {
				color: #fff;
			}
		}
		.ag-header-group-cell::after {
			display: none;
		}
		.ag-header-cell-sorted-none::after {
			display: none;
		}
		.ag-header-cell {
			font-weight: bold;
			font-size: 8px;
			font-family: 'Roboto';
			text-transform: uppercase;
			.ag-header-cell-text {
				white-space: pre-line;
			}
			.ag-icon-menu {
				display: none;
			}
			&.ag-numeric-header {
				text-align: right;
			}
		}
		.ag-header-group-cell-no-group {
			background-color: #ffffff;
			border: none;
		}
		.ag-header-group-cell-label {
			justify-content: center;
		}

		.ag-row {
			background-color: transparent;
			border-color: ${colors.grey3};

			&.ag-row-last {
				border-bottom: none;
			}
			&:hover {
				background-color: rgba(0, 255, 0, 0.12);
			}
			.ag-cell {
				font-size: 8px;
				font-weight: normal;
				color: ${colors.grey5};
			}
		}

		.ag-floating-top-viewport {
			border: none;
		}

		.ag-floating-top {
			border-color: ${colors.grey3};
		}

		.ag-row-pinned {
			border: none;

			&.ag-row-last {
				border: none;
			}

			.ag-cell {
				font-weight: bold;
			}
		}

		.ag-header-row-column {
			border-bottom: 1px solid ${colors.grey3};
		}
	}
`;
